var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step-title',{attrs:{"title":_vm.$t('checkout.select_variant'),"smaller":_vm.smaller,"step-color":_vm.stepColor,"step":_vm.step}})}
var staticRenderFns = []

export { render, staticRenderFns }